import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M2.667 12.667h10.666V8h1.334v5.333A.667.667 0 0114 14H2a.666.666 0 01-.667-.667V8h1.334v4.667zm6-6.667v4.667H7.333V6H4l4-4 4 4H8.667z'
      ></path>
    </svg>
  )
}

export default Icon
